import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import {unmountComponentAtNode} from 'react-dom';
import {clrwidgate,insertpost,getcolval,getcolnotval} from './userdefaultdata';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';

export const Friends=(txt:any,isndr:any)=>{

var userfriends = [
		{mid:0,mrcvuserid:0,msndruserid:0,mmsg:"",mccd:"",mpfpid:0,misf:"0",mrs:0,misread:0,
		msts:0,rqstnm:"",rcvnm:"",rcvmpfpid:0,risf:"0"}
		 
		];
if(txt) userfriends = txt;
//alert(JSON.stringify(txt));
userfriends.shift();
return(
     <div>
      <div className="per100" id="postmain">
	 <div className="postinchat" style={{overflowX:'hidden',overflowY:'auto',height:''}}>
	  <div className="postingchatdiv">
          
	    <table className="postingtable">
		
		<tbody>
			{userfriends.map((row,index)=>(
			<tr>
			   <td style={{width:'67%'}} className="pfptd">
                            <div className="cuserid">
                            
                            {isndr?(
                            <div>
                            <div className="chtlnpfp">
				{row.misf=="1"?(
	  			<Girlspfp  itemid={row.rcvmpfpid} wth={'20px'}  hgt={'20px'}/>

          			):(
          			<Boyspfp  itemid={row.rcvmpfpid} wth={'20px'}  hgt={'20px'}/>

				)}

			    </div>
   			    <div style={{color:row.mccd}} className="txtlnpfp">
                            
			   	{row.rcvnm}
                             </div>
                             </div>
                             ):(
			       <div>	
                               <div className="chtlnpfp">
				{row.risf=="1"?(
	  			<Girlspfp  itemid={row.mpfpid} wth={'20px'}  hgt={'20px'}/>

          			):(
          			<Boyspfp  itemid={row.mpfpid} wth={'20px'}  hgt={'20px'}/>

				)}

			    </div>
                               <div style={{color:row.mccd}} className="txtlnpfp">

				{row.rqstnm}
                                </div>
                               </div>
			     )}	
			    
                            </div>
		           </td>
                           
                          {isndr?(
			  <td style={{width:'30%'}}>
                            <div className="frndsts" style={{color:row.mccd}}>
                             {row.msts==0?(<span>Request</span>)
				:row.msts==1?(
                                 

					<span>Add</span>
			          
				)
                                 :(
				   

					<span>Reject</span>
				    
				)
				}

			    </div>	
			   </td>
                           ):(
                           <td style={{width:'30%'}}>
                           <a href="#" className="blanka"  onClick={e=>Addrjectfnd(e,row.mid,1)} title="Add Friend">
                            <div className="frndsts" style={{color:row.mccd}}>
				Add
			    </div>
                           </a>	
			    <a href="#" className="blanka"  onClick={e=>Addrjectfnd(e,row.mid,2)} title="Reject Friend">
                            <div className="frndsts" style={{color:row.mccd}}>
				Reject
			    </div>	
			    </a>	
			   </td>
			   )}	
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>

     </div>
);

}
export const gstchaddtoboat=(chats:any)=>{
}
export const Addrjectfnd=(e:any,id:any,sts:any)=>{

 const apiurl =  '/updatefrndrqst';
 const obj = {fid:id,stsid:sts};
 insertpost(apiurl,obj);
}

export const Itemaddc =(itm:any,mt:any,id:any,opt:any)=>{

var sender = true;
var addopt = true;
if(mt!='snd') sender = false;
if(mt=='snd') addopt = false;
const iobj = {oms: itm,omt: mt,oid:id,issend:sender,isopt:addopt};

return iobj;
}
export const addtoexecboatc=(ce:any)=>{
}

export const scrolldowncboat=()=>{
const buffer = document.getElementById('chatdives') as HTMLElement;
if(buffer){

 buffer.scrollTop = buffer.scrollHeight;
}

}

export const uchtlnpfp = (props:any) => {
    
      return (

       <div>
	{props.isf?(
	  <img src={usrf1} className="c-pfp-img" />
          ):(
          <img src={usrm1} className="c-pfp-img" />
	)}
	
       </div>	
    
   
      );

};
